import { Injector } from '@angular/core';
import { RoleService } from '../../services/role.service';

export function SelectRoleForm(injector: Injector) {
    return {
        groups: [{
            id: 1,
            name: 'General',
            order: 1,
            sections: [{
                id: 'section',
                order: 1,
                rows: [{
                    id: 'row',
                    order: 1,
                    elements: [{
                        id: 'role',
                        type: 'select',
                        name: 'role',
                        label: 'Role',
                        validation: {},
                        config: {
                            url: injector.get(RoleService).all(true),
                            relation: true,
                            searchKeyColumn: 'id',
                            searchQueryColumn: 'name',
                            searchDisplayColumn: 'name'
                        },
                        attributes: {
                            placeholder: 'Role',
                            title: 'Role'
                        }
                    }]
                }]
            }]
        }]
    };
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/authentication/forms/role/select-role.form.ts